import React from 'react';
import Dashboard from '../../components/dashboard/dashboard';

const DashboardPage: React.FC = () => {
  return <Dashboard />;
};

export default DashboardPage;
